**Deprecated:** Use `basis` instead.
